import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import ColorGridMemory from "./ColorGridMemory.vue";
export default {
  name: "ColorGridMemoryRender",
  components: {
    ColorGridMemory
  },
  props: {
    difficulty: {
      type: Object,
      default: () => ({
        showMs: 1000,
        gapMs: 500
      })
    },
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      replayTick: 0
    };
  },
  computed: {
    showMs() {
      return Number(this.difficulty?.showMs || 1000);
    },
    gapMs() {
      return Number(this.difficulty?.gapMs || 500);
    },
    correctAnswers() {
      return this.parseAnswer(this.data?.rightAnswer);
    },
    reviewAnswers() {
      return this.parseAnswer(this.review?.answer);
    },
    redAnswerLength() {
      return (this.data?.timeline || []).filter(item => item.color === 'red').length;
    }
  },
  methods: {
    replayTimeline() {
      this.replayTick += 1;
    },
    onAnswer(answer) {
      this.$emit('answer', answer);
    },
    parseAnswer(answer) {
      if (!answer) {
        return [];
      }
      return answer.split(',').map(item => item.trim()).filter(item => item !== '').map(item => Number(item)).filter(item => !Number.isNaN(item));
    },
    formatCell(cell) {
      const size = this.data?.gridSize || 1;
      const row = Math.floor(cell / size) + 1;
      const col = cell % size + 1;
      return `${row}-${col}`;
    }
  }
};